var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-container"},[(_vm.$slots.default)?_vm._t("default"):[_vm._v(" "+_vm._s(_vm.data ? _vm.data[0].label : '')+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }